import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"

const slides = [
  {
    title: "Welcome to eShopZone",
    subtitle: "Your ultimate online marketplace for everything you need. Discover amazing products from trusted sellers, enjoy great deals, and shop with confidence.",
    cta: "Start Shopping",
    ctaLink: "/products",
    bg: "from-[#4F8CFF] via-[#A0C1FF] to-[#F5F8FF]",
  },
  {
    title: "⚡ Flash Sale — Up to 60% Off",
    subtitle: "Limited-time deals on top brands. Grab your favorites before they're gone — prices this low won't last long!",
    cta: "Shop Deals",
    ctaLink: "/products",
    bg: "from-[#FF6B6B] via-[#FFB800] to-[#FFE0B2]",
  },
  {
    title: "🌟 New Arrivals Are Here",
    subtitle: "Be the first to discover fresh products from our newest sellers. Updated daily with trending items just for you.",
    cta: "Explore Now",
    ctaLink: "/products",
    bg: "from-[#20B2AA] via-[#48C9B0] to-[#E0F7F5]",
  },
]

const Hero = () => {
  const [current, setCurrent] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length)
    }, 5000)
    return () => clearInterval(timer)
  }, [])

  const slide = slides[current]

  return (
    <div id="main-content" className="relative min-h-[70vh] 800px:min-h-[100vh] w-full flex items-center justify-center overflow-hidden pt-16">
      {/* Background layers */}
      {slides.map((s, i) => (
        <div
          key={i}
          className={`absolute inset-0 bg-gradient-to-br ${s.bg} transition-opacity duration-700 ease-in-out ${
            i === current ? "opacity-100" : "opacity-0"
          }`}
        />
      ))}

      {/* Overlay for text clarity */}
      <div className="absolute inset-0 bg-black bg-opacity-20 z-0" />

      {/* Content */}
      <div className="relative z-10 w-[90%] 800px:w-[60%] flex flex-col items-center text-center py-12">
        <h1
          key={`title-${current}`}
          className="text-[40px] leading-[1.1] 800px:text-[64px] font-extrabold text-white drop-shadow-lg mb-4 font-sans animate-[fadeIn_0.5s_ease-out]"
        >
          {slide.title}
        </h1>
        <p
          key={`sub-${current}`}
          className="pt-2 text-[18px] 800px:text-[22px] font-medium text-white/90 mb-8 max-w-2xl animate-[fadeIn_0.5s_ease-out_0.1s_both]"
        >
          {slide.subtitle}
        </p>
        <Link to={slide.ctaLink} className="inline-block">
          <div className="px-8 py-3 bg-white hover:bg-gray-100 text-[#4F8CFF] transition-colors duration-200 rounded-full shadow-lg hover:shadow-xl hover:scale-105 transform transition-all">
            <span className="font-semibold text-[20px] tracking-wide">
              {slide.cta}
            </span>
          </div>
        </Link>

        {/* Dot indicators */}
        <div className="flex gap-3 mt-10">
          {slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-3 h-3 rounded-full transition-all duration-300 ${
                i === current
                  ? "bg-white w-6"
                  : "bg-white/50 hover:bg-white/80"
              }`}
              aria-label={`Go to slide ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default Hero